export const LOAD_NOTIFICATIONS_SUCCESS = "LOAD_NOTIFICATIONS_SUCCESS";
export const NEW_NOTIFICATION_RECEIVED = "NEW_NOTIFICATION_RECEIVED";
export const NOTIFICATION_READ_SUCCESS = "NOTIFICATION_READ_SUCCESS";
export const CLEAR_NOTIFICATIONS_SUCCESS = "CLEAR_NOTIFICATIONS_SUCCESS";
